import React from 'react';
import { IconListCheck, IconArrowRight } from '@tabler/icons-react';
interface TaskPreviewCardProps {
  taskCount: number;
  title: string;
  onClick: () => void;
  categoryColor?: string;
}
export function TaskPreviewCard({
  taskCount,
  title,
  onClick,
  categoryColor = '#B0EC9C'
}: TaskPreviewCardProps) {
  return <div onClick={onClick} className="group cursor-pointer bg-white border border-yeppy-text border-opacity-10 rounded-2xl overflow-hidden transition-all duration-200 mt-3 max-w-sm" data-id="element-357">
      <div className="flex items-stretch" data-id="element-358">
        {/* Accent strip with category color */}
        <div className="w-1.5 flex-shrink-0" style={{
        backgroundColor: categoryColor
      }} data-id="element-359" />

        <div className="p-4 flex-1" data-id="element-360">
          <div className="flex items-center gap-2 mb-2" data-id="element-361">
            <span className="inline-flex items-center justify-center text-yeppy-text text-xs font-semibold px-2 py-0.5 rounded-full" style={{
            backgroundColor: `${categoryColor}33`
          }} data-id="element-362">
              <IconListCheck className="w-3 h-3 mr-1" data-id="element-363" />
              {taskCount} attività proposte
            </span>
          </div>

          <h3 className="font-rubik text-yeppy-text mb-3 text-[14px] font-[500]" data-id="element-364">
            {title}
          </h3>

          <div className="flex items-center text-sm font-poppins text-yeppy-text text-opacity-60 transition-colors" data-id="element-365">
            Visualizza dettagli
            <IconArrowRight className="w-4 h-4 ml-1 transform transition-transform" data-id="element-366" />
          </div>
        </div>
      </div>
    </div>;
}